import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileConfig } from './../../profile.config';

@Component({
  selector: 'view-profile-references',
  templateUrl: './view-profile-references.component.html',
  providers: []
})
//view-profile-references.template
export class ViewProfileReferencesComponent {
  @Input() viewProfileData: Object;
  profileKey: string;

  constructor() {
  }

  ngOnInit() {
    this.profileKey = ProfileConfig.getViewProfileReferencesKey();
  }
}